import React, {FunctionComponent} from "react";
import ReactMarkdown from "react-markdown";
import {OpenSiteButtonProps} from "../openSiteButton";
import {BackgroundShape} from "../backgroundShape/backgroundShape.component";
import {OpenSiteMiddleCard} from "../../interfaces/strapi";
import {DialogButton} from "../dialogButton";

const styles = require("./middleCard.component.scss");

interface MiddleCardProps extends OpenSiteMiddleCard{
    buttonProps?: OpenSiteButtonProps;
    fixedButtonSpot?: boolean;
    contentPosition?: 'top' | 'bottom';
}


export const MiddleCard: FunctionComponent<MiddleCardProps> = props => {
    const {title, description, image, reverseDirection, iconImage, ctaText, modalType,
        bigImage, buttonProps, backgroundShape, sectionPadding, fixedButtonSpot, contentPosition} = props;
    return (
        <div className={styles.cardBackground}>
            {!!backgroundShape &&
                <BackgroundShape {...backgroundShape}/>
            }
            <div className={`${styles.cardWrapper} ${sectionPadding ? styles[sectionPadding] : ''} ${reverseDirection ? styles.left : styles.right}`}>
                <div className={`${styles.cardContainer} ${reverseDirection ? styles.reverseDirection : ''}  ${bigImage ? styles.bigImage : ''}`}>
                    <div className={`${styles.cardTextContainer}`}>
                        <div className={styles.cardText}>
                            {!!iconImage &&
                            <div className={styles.cardIcon}>
                                <img src={iconImage?.url} alt=""/>
                            </div>
                            }
                            <h2>
                                {title}
                            </h2>
                            <div className={styles.cardDescription}>
                                <ReactMarkdown source={description}/>
                            </div>
                            <div className={`${styles.demoButtonContainer} ${fixedButtonSpot ? styles.fixedSpot : ''}`}>
                                <DialogButton text={ctaText} modalType={modalType} {...buttonProps}/>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.cardImage} 
                        ${contentPosition ? styles[contentPosition] : ''}`}>
                        <img className={styles.middleImg} src={image?.url} alt=""/>
                    </div>
                </div>
            </div>
        </div>
    );
};
